export default __webpack_public_path__ + "static/media/background.02b32d0b.mp4";